var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Content",
    {
      class: { "with-app-sidebar": _vm.currentApp },
      attrs: {
        "app-name": "settings",
        "content-class": { "icon-loading": _vm.loadingList },
        "navigation-class": { "icon-loading": _vm.loading }
      }
    },
    [
      _c("AppNavigation", [
        _c(
          "ul",
          { attrs: { id: "appscategories" } },
          [
            _c("AppNavigationItem", {
              attrs: {
                id: "app-category-your-apps",
                to: { name: "apps" },
                exact: true,
                icon: "icon-category-installed",
                title: _vm.t("settings", "Your apps")
              }
            }),
            _vm._v(" "),
            _c("AppNavigationItem", {
              attrs: {
                id: "app-category-enabled",
                to: { name: "apps-category", params: { category: "enabled" } },
                icon: "icon-category-enabled",
                title: _vm.t("settings", "Active apps")
              }
            }),
            _vm._v(" "),
            _c("AppNavigationItem", {
              attrs: {
                id: "app-category-disabled",
                to: { name: "apps-category", params: { category: "disabled" } },
                icon: "icon-category-disabled",
                title: _vm.t("settings", "Disabled apps")
              }
            }),
            _vm._v(" "),
            _vm.updateCount > 0
              ? _c(
                  "AppNavigationItem",
                  {
                    attrs: {
                      id: "app-category-updates",
                      to: {
                        name: "apps-category",
                        params: { category: "updates" }
                      },
                      icon: "icon-download",
                      title: _vm.t("settings", "Updates")
                    }
                  },
                  [
                    _c(
                      "AppNavigationCounter",
                      { attrs: { slot: "counter" }, slot: "counter" },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.updateCount) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("AppNavigationItem", {
              attrs: {
                id: "app-category-your-bundles",
                to: {
                  name: "apps-category",
                  params: { category: "app-bundles" }
                },
                icon: "icon-category-app-bundles",
                title: _vm.t("settings", "App bundles")
              }
            }),
            _vm._v(" "),
            _c("AppNavigationSpacer"),
            _vm._v(" "),
            _vm.settings.appstoreEnabled
              ? [
                  _c("AppNavigationItem", {
                    attrs: {
                      id: "app-category-featured",
                      to: {
                        name: "apps-category",
                        params: { category: "featured" }
                      },
                      icon: "icon-favorite",
                      title: _vm.t("settings", "Featured apps")
                    }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.categories, function(cat) {
                    return _c("AppNavigationItem", {
                      key: "icon-category-" + cat.ident,
                      attrs: {
                        icon: "icon-category-" + cat.ident,
                        to: {
                          name: "apps-category",
                          params: { category: cat.ident }
                        },
                        title: cat.displayName
                      }
                    })
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("AppNavigationItem", {
              attrs: {
                id: "app-developer-docs",
                href: "settings.developerDocumentation",
                title: _vm.t("settings", "Developer documentation") + " ↗"
              }
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "AppContent",
        {
          staticClass: "app-settings-content",
          class: { "icon-loading": _vm.loadingList }
        },
        [
          _c("AppList", {
            attrs: {
              category: _vm.category,
              app: _vm.currentApp,
              search: _vm.searchQuery
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.id && _vm.currentApp
        ? _c(
            "AppSidebar",
            { on: { close: _vm.hideAppDetails } },
            [
              _c("AppDetails", {
                attrs: { category: _vm.category, app: _vm.currentApp }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }